import { makeAutoObservable } from 'mobx'
import { type IAgentHandoffNotifySettings } from 'entities/Chatbot'

export class HandoffNotifySettingsStore {
  constructor(
    readonly initialState?: IAgentHandoffNotifySettings,
    private parent?: {
      notifySettings: IAgentHandoffNotifySettings
      setNotifySettings: (notify_settings: IAgentHandoffNotifySettings) => void
    }
  ) {
    this._notifySettings = initialState ?? {
      notify_enabled: false,
      contact_owner: false,
      all_inbox_members: false,
      conversation_assignee: false,
      additional_users: [],
    }
    makeAutoObservable(this)
  }

  private _error = ''
  get error() {
    return this._error
  }

  validate = () => {
    let error = ''
    if (this.isNotifyTeamMembers) {
      if (
        !this.notifyContactOwner &&
        !this.notifyConversationAssignee &&
        !this.notifyAllInboxMembers &&
        !this.notify_additional_users.length
      ) {
        error = 'Please select at least one team member'
      }
    }
    this._error = error
    return error
  }

  private _notifySettings: IAgentHandoffNotifySettings
  get notifySettings() {
    return this.parent?.notifySettings ?? this._notifySettings
  }

  private set_handoff_notify_settings_value = (value: IAgentHandoffNotifySettings) => {
    if (this.parent) {
      this.parent.setNotifySettings({
        ...this.parent.notifySettings,
        ...value,
      })
    } else {
      this._error = ''
      this._notifySettings = {
        ...this._notifySettings,
        ...value,
      }
    }
  }

  get isNotifyTeamMembers() {
    return !!this.notifySettings.notify_enabled
  }

  setNotifyTeamMembers = (active: boolean) => {
    this.set_handoff_notify_settings_value({ notify_enabled: active })
  }

  get notifyConversationAssignee() {
    return !!this.notifySettings.conversation_assignee
  }

  setNotifyConversationAssignee = (value: boolean) => {
    this.set_handoff_notify_settings_value({ conversation_assignee: value })
  }

  get notifyContactOwner() {
    return !!this.notifySettings.contact_owner
  }

  setNotifyContactOwner = (value: boolean) => {
    this.set_handoff_notify_settings_value({ contact_owner: value })
  }

  get notifyAllInboxMembers() {
    return !!this.notifySettings.all_inbox_members
  }

  setNotifyAllInboxMembers = (value: boolean) => {
    this.set_handoff_notify_settings_value({ all_inbox_members: value })
  }

  get notify_additional_users() {
    return this.notifySettings.additional_users || []
  }

  set_notify_additional_users = (value: number[]) => {
    this.set_handoff_notify_settings_value({ additional_users: value })
  }
}
